const mediaItems = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    tag: '科幻巨制',
    duration: '2h 18min',
    rating: '9.2',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20style%20with%20deep%20space%20nebula%20background%2C%20dramatic%20blue%20and%20purple%20cosmic%20lighting%2C%20epic%20spaceship%20silhouette%2C%20professional%20movie%20poster%20composition%2C%20clean%20dark%20background%20with%20starlight%20effects%2C%20cinematic%20widescreen%20aesthetic%2C%20high%20contrast%20atmospheric%20render&width=800&height=600&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '长安十二时辰',
    tag: '古装悬疑',
    duration: '45min/集',
    rating: '8.9',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20architecture%20at%20night%20with%20warm%20lantern%20glow%2C%20traditional%20rooftops%20silhouette%20against%20moonlit%20sky%2C%20atmospheric%20mist%20and%20soft%20golden%20lighting%2C%20historical%20drama%20cinematic%20style%2C%20moody%20dark%20ambient%20with%20rich%20red%20and%20gold%20accents%2C%20elegant%20composition&width=800&height=600&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '深海探秘',
    tag: '纪录片',
    duration: '1h 42min',
    rating: '9.5',
    img: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20ethereal%20bioluminescent%20creatures%2C%20rays%20of%20sunlight%20penetrating%20dark%20blue%20water%2C%20mysterious%20deep%20sea%20atmosphere%2C%20documentary%20style%20cinematography%2C%20clean%20minimal%20composition%20with%20teal%20and%20indigo%20tones%2C%20professional%20underwater%20photography%20aesthetic&width=800&height=600&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '笑傲江湖之风云再起',
    tag: '动作武侠',
    duration: '2h 05min',
    rating: '8.7',
    img: 'https://readdy.ai/api/search-image?query=Majestic%20Chinese%20mountain%20landscape%20with%20misty%20peaks%20and%20pine%20trees%2C%20dramatic%20golden%20hour%20lighting%2C%20martial%20arts%20film%20cinematic%20aesthetic%2C%20warm%20amber%20and%20deep%20green%20color%20palette%2C%20epic%20widescreen%20composition%2C%20atmospheric%20fog%20and%20soft%20sunbeams%2C%20classic%20wuxia%20visual%20style&width=800&height=600&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '都市夜话',
    tag: '都市情感',
    duration: '1h 55min',
    rating: '8.4',
    img: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20night%20with%20reflective%20glass%20buildings%2C%20warm%20interior%20light%20spilling%20through%20windows%2C%20romantic%20urban%20atmosphere%2C%20soft%20bokeh%20city%20lights%2C%20contemporary%20drama%20film%20aesthetic%2C%20clean%20elegant%20composition%20with%20deep%20navy%20and%20golden%20yellow%20tones%2C%20cinematic%20color%20grading&width=800&height=600&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            精彩预告
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精选当前最受关注的影视内容，每一部都值得你花时间品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-[10px] font-medium rounded bg-accent-500 text-white whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 text-[10px] font-bold rounded bg-black/50 text-accent-300 whitespace-nowrap">
                  {item.rating}
                </span>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-[11px] text-white/80">{item.duration}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}